import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleQuality } from '@/mocks/articles';

export default function QualityTipsPage() {
  return <ArticleLayout article={articleQuality} />;
}